import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/g2pigoue_image.png";

const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Seller Guide", href: "/seller-guide" },
  { label: "Buyer Guide", href: "/buyer-guide" },
  { label: "Testimonials", href: "/testimonials" },
];

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-md border-b border-[#e2e5e2]"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center"
            data-testid="header-logo"
          >
            <img 
              src={LOGO_URL} 
              alt="Spivey Realty Group" 
              className="h-12 md:h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === item.href
                    ? "text-[#00453d]"
                    : "text-[#4d6153] hover:text-[#132723]"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Right Side - Phone + Mobile Menu */}
          <div className="flex items-center gap-4">
            {/* Phone CTA */}
            <a 
              href="tel:+13605810167" 
              className="flex items-center gap-2 text-[#132723] hover:text-[#00453d] transition-colors"
              data-testid="header-phone"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium text-sm md:text-base hidden sm:inline">(360) 581-0167</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-[#132723]"
              data-testid="mobile-menu-button"
            >
              {isMobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav 
            className="md:hidden py-4 border-t border-[#e2e5e2]"
            data-testid="mobile-nav"
          >
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 text-base font-medium transition-colors ${
                  location.pathname === item.href
                    ? "text-[#00453d]"
                    : "text-[#4d6153] hover:text-[#132723]"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a 
              href="tel:+13605810167" 
              className="flex items-center gap-2 py-3 text-[#132723] font-medium sm:hidden"
            >
              <Phone className="w-4 h-4" />
              (360) 581-0167
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
